export default __webpack_public_path__ + "assets/icons/tel.222e4a54.svg";